module.exports = __webpack_public_path__ + "static/media/2477.da59a4d7.png";